import Cookies from "js-cookie";
import { useEffect, useState } from "react";

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("cookieConsent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    Cookies.set("cookieConsent", "true", { expires: 30, sameSite: "Strict" });
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookies_banner">
      <div className="container cookie_banner_content">
        <div className="cookie_banner_logo">
            <img src="/images/ftr_logo.png" />
          
          </div>
 
          <div className="cb_content">
          <p >
            We use cookies to improve your experience, remember login details,
            provide secure access, and deliver personalized content.
          </p>
          <button
          onClick={acceptCookies}
          className="bg-blue-500 text-white px-6 py-2 rounded-lg text-sm hover:bg-blue-600 transition-all currsor: pointer"
        >
          Accept Cookies
        </button>
        </div>
      </div>
    </div>
  );
}
